module.exports = "/_next/static/images/9af393c810ca5396700ae7c61ffe5aa5-left-side-mobile.jpg.webp";